import React from 'react';
import { cn } from '@/lib/utils';

interface LoadingSkeletonProps {
  className?: string;
  variant?: 'text' | 'circular' | 'rectangular' | 'card';
  lines?: number;
  height?: number | string;
  width?: number | string;
}

export const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({
  className,
  variant = 'rectangular',
  lines = 1,
  height,
  width
}) => {
  const baseClasses = "animate-pulse bg-gray-200 dark:bg-gray-700";
  
  if (variant === 'text') {
    return (
      <div className={cn("space-y-2", className)}>
        {Array.from({ length: lines }).map((_, index) => (
          <div
            key={index}
            className={cn(
              baseClasses,
              "h-4 rounded",
              index === lines - 1 && lines > 1 ? "w-3/4" : "w-full"
            )}
            style={{ height, width }}
          />
        ))}
      </div>
    );
  }

  if (variant === 'circular') {
    return (
      <div
        className={cn(baseClasses, "rounded-full", className)}
        style={{ 
          height: height || 40, 
          width: width || 40 
        }}
      />
    );
  }

  if (variant === 'card') {
    return (
      <div className={cn("space-y-4 p-4", className)}>
        <div className={cn(baseClasses, "h-48 rounded-lg")} />
        <div className="space-y-2">
          <div className={cn(baseClasses, "h-4 rounded w-3/4")} />
          <div className={cn(baseClasses, "h-4 rounded w-1/2")} />
        </div>
        <div className={cn(baseClasses, "h-8 rounded w-24")} />
      </div>
    );
  }

  return (
    <div
      className={cn(baseClasses, "rounded", className)}
      style={{ height: height || 20, width }}
    />
  );
};